module.exports = __webpack_public_path__ + "img/3.43e8462d.jpg";